import React, { useState, useEffect, useContext } from 'react';
import { Paper, Box, Grid, Chip, Typography, TextField, Autocomplete, CircularProgress, Pagination } from '@mui/material';
import ApiService from '../../functions/apiService';
import moment from 'moment';
// import './settings.css'
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from '../../context/AuthContext';
import { toast } from 'react-toastify';
import { DataGrid } from '@mui/x-data-grid';

const PersonalPayroll = () => {
	const { user, permission, pages } = useContext(AuthContext)
	const [loading, setLoading] = useState(false);
	const [payrollList, setPayrollList] = useState([]);
	const timeFormat = (timeStr) => timeStr?.slice(0, 5);

	const columns = [
		{
			field: 'name', headerName: 'Name', flex: 1, minWidth: 150,
			valueGetter: (params) => { return (params?.row?.employee?.fullName) }
		},

		{
			field: 'Month', headerName: 'Approval Month', flex: 1, minWidth: 160, valueGetter: (params) => params?.row?.approval_month_formatted
		},

		{
			field: 'status', headerName: 'Status', flex: 1, minWidth: 130,
			renderCell: (params) => {
				return (
					<Chip style={{ width: '60px' }}
						label={params?.row?.Status?.charAt(0).toUpperCase() + params?.row?.Status?.slice(1)}
						className={params?.row?.Status == 'approved' ? 'day-chip' : 'night-chip'} />)
			}
		},

		{
			field: 'time', headerName: 'Created on', flex: 1, minWidth: 160,
			renderCell: (params) => {
				return (moment(params?.row?.Create_Time).format("MMM YYYY") + ' ' + varFormatTime(timeFormat(moment(params?.row?.Create_Time).format("HH:mm:ss")), user?.Time_Format))
			}
		},

		{
			field: 'report', headerName: 'View Report', flex: 1, minWidth: 160,
			renderCell: (params) => (
				<a target="blank" href={params?.row?.Pdf_Url}>
					<div>
						<img src='/images/cloud.png' width={20} height={20} />
					</div>
				</a>
			)
		},
	]

	const getPayrollList = (loader = true) => {
		if (loader) {
			setLoading(true);
		}
		ApiService.get(permission.includes('global_admin') ? "/payroll/all-payroll-report" : "/payroll/get-payroll-report")
			.then(({ data }) => {
				var tempArr = []
				data.data.map((Id) => {
					var obj = Id
					obj.id = Id.Id
					tempArr.push(obj)
				})
				setPayrollList(tempArr)
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			});
	};

	useEffect(() => {
		getPayrollList()
	}, [])

	return (
		<>
			{loading ? (
				<>
					<Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
						<CircularProgress />
					</Paper></>
			) :
				(
					<>
						<Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
							<Grid container spacing={2} className='align-items-center'>

								{/* Heading */}
								<Grid item xs={10} md={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
									<Typography variant="h5">Personal Payroll List</Typography>
								</Grid>
							</Grid>

							{(!payrollList || payrollList.length == 0) ?
								<div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 565 }}>
									<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
									<span className='mt-4' style={{ color: '#555555' }}>
										No Payroll Found
									</span>
								</div>
								:
								<>
									<div className='mt-4'>
										<DataGrid
											rows={payrollList}
											columns={columns}
											checkboxSelection={false}
											hideFooter={true}
											sx={{
												"& .MuiDataGrid-columnHeaderTitleContainer": {
													display: "flex !important",
												},
												"& .MuiTablePagination-selectLabel": {
													marginBottom: "0 !important"
												},
												"& .MuiTablePagination-displayedRows": {
													marginBottom: "0 !important"
												},
												"& .MuiDataGrid-columnHeader": {
													minWidth: "100px",
												},
											}}
										/>
									</div>
								</>
							}
						</Paper>
					</>
				)
			}
		</>
	)
}

export default PersonalPayroll